import { ButtonType, LargeButton } from '@checkmarx/cx-ui';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import ValidationTopErrorMessage from '../../portal/controls/validationTopErrorMessage';
import PortalTextBox from '../../portal/portalTextBox';
import PortalCheckBox from '../../portal/controls/checkbox';

@inject('translationsStore', 'authStore', 'authenticationProvidersStore') @observer
export default class twoFALoginForm extends Component {
    
    componentWillUnmount() {
        this.props.authStore.resetTwoFAForm();
    }
    
    handleCodeChange = e => this.props.authStore.setAuthCode(e.target.value);

    handleRecoveryCodeClick = e => {
        this.props.authStore.setLoginStep(this.props.authStore.loginSteps.recoveryCodeForm);
    };

    toggleRememberBrowser = e => {
        this.props.authStore.toggleRememberTwoFABrowser();
    }
    
    handleSubmitForm = (e) => {
        e.preventDefault();
        const isValid = this.props.authStore.validateTwoFactorLoginForm();
        
        if (isValid === false) {
            return;
        }
        this.props.authStore.setInProgress(true);
        this.props.authStore.isTwoFactorError = false;
        this.props.authStore.twoFactorErrorMessage = '';
        
        this.props.authStore.login().then((response) => {
            window.localStorage.setItem('authStoreTenant', this.props.authStore.values.tenant);
            window.location.href = this.props.returnUrl;
            this.props.authStore.setInProgress(false);
        });
    };

    render() {
        const { values, twoFactorErrorMessage, inProgress } = this.props.authStore;

        return (
            <div className="account-form">
                <form onSubmit={this.handleSubmitForm}>
                    <div>
                        <div style={{ fontSize: 'larger' }}>{this.props.translationsStore.translate('TWOFACTOR_REQUIRED_MESSAGE')}</div>
                        <div style={{ paddingTop: '50px', fontSize: '14px' }}>
                            {this.props.translationsStore.translate('TWOFACTOR_LOGIN_MESSAGE')}
                        </div>
                        <ValidationTopErrorMessage errorMessage={this.props.authStore.twoFactorErrorMessage} />
                        <PortalTextBox
                            id='txtCode'
                            dataCy='code'
                            floatingLabelText={this.props.translationsStore.translate('AUTHENTICATIONCODE')}
                            onChange={this.handleCodeChange}
                            autoComplete='on'
                            width='325px'
                            value={ values.authenticationCode }
                        />
                        <LargeButton
                            type='submit'
                            id='btnVerifyCode'
                            dataCy='login-button'
                            inProgress={inProgress}
                            text={this.props.translationsStore.translate('VERIFY')}
                            style={{ marginTop: '25px', width: '325px', marginBottom: '25px' }}
                        />
                        <PortalCheckBox
                            checked={this.props.authStore.values.rememberTwoFABrowser}
                            onCheck={this.toggleRememberBrowser}
                            label={this.props.translationsStore.translate('REMEMBER_BROWSER')}
                        />
                    </div>
                    <div style={{ paddingTop: '50px', fontSize: '14px' }}>{this.props.translationsStore.translate('TWOFA_RECOVERY_MESSAGE1')} <a style={{ cursor: 'pointer' }} onClick={this.handleRecoveryCodeClick}>{this.props.translationsStore.translate('TWOFA_RECOVERY_MESSAGE2')}</a></div>
                </form>
            </div>);

    }
}